<template>
    <div class="main-content">
        <p>
            <input type="file"   id="my_file_input" @change="inputFile"/>
        </p>
        <p><pre>{{ test | pretty }}</pre></p>
    </div>
</template>
<script>
    import readXlsxFile from 'read-excel-file'

    const uuidv4 = require('uuid/v4');

    export default {
        name: 'excelToJson',
        filters: {
            pretty: function(value) {
                return value
                // return JSON.stringify(value, null, 2);
            }
        },
        data() {
            return {
                metaDataFile: null,
                test: {
                    id: uuidv4(),
                    title: 'Certificación ONiAd',
                    attemp_num_questions: 15,
                    attemp_pass_correct_answers: 12,
                    attemp_time_limit_minutes: 15,
                    description: 'Consigue la certificación ONiAd para ser el master del universo de la publicidad programática.',
                    topics: [],
                    questions: []
                }
            }
        },
        mounted() {

        },
        methods: {
            inputFile(event){
                readXlsxFile(event.target.files[0]).then((rows) => {
                    this.generateQuestionsAndTopics(rows);
                    // `rows` is an array of rows
                    // each row being an array of cells.
                }).then(()=>{
                    this.$store.dispatch({type:'postAdminTest',data:this.test}).then((data)=>{
                        console.log(data)
                    }).catch(console.error)
                });
            },
            generateQuestionsAndTopics(r){
                let topic;
                let subtopic;
                // let question;
                for (let i = 0;i<r.length;i++){
                    topic = null;
                    subtopic = null;
                    // Buscar si existe el topic
                    topic = this.test.topics.find((t)=>{
                        return t.title === r[i][0]
                    });
                    if (topic === undefined){
                        topic = {id:uuidv4(),title:r[i][0],parent:null};
                        this.test.topics.push(topic)
                    }

                    // Buscar el subTopic
                    subtopic = this.test.topics.find((t)=>{
                        if (t.title === r[i][1]){
                            if (t.title === "Publicidad programatica")
                                console.log('está');
                            return t
                        }
                    });
                    if (subtopic === undefined){
                        topic = {id:uuidv4(),title:r[i][1],parent:topic.id};
                        this.test.topics.push(topic)
                    }
                    // Añadir la pregunta y respuestas

                    this.test.questions.push({
                        id: uuidv4(),
                        text: r[i][2],
                        topic: topic.id,
                        options: [
                            {id:uuidv4(),text:r[i][3],valid:true},
                            {id:uuidv4(),text:r[i][4],valid:false},
                            {id:uuidv4(),text:r[i][5],valid:false},
                            {id:uuidv4(),text:r[i][6],valid:false}
                        ]
                    })
                }
            }
        }
    }
</script>
<style lang="scss">

</style>